import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const editFields = fields.slice()
editFields.unshift({
  name: 'Account Name',
  prop: 'account_id',
  type: 'autocomplete',
  references: 'admin/accounts',
  referenceProp: 'account_name',
  // @ts-ignore
  disabled: true
})

const EditOrder = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Order'
      fields={editFields}
      apiPath={`admin/orders/${props.params.orderId}`}
      successRedirectPath='/ecommerce/orders'
      buildMenuItems={menuItems}
    />
  )
}

export default EditOrder
